export var NUMBERING_MESSAGE_PREFIX = "ui-br-legaldeposits.periodicalCheck.settings.numbering";
var EMPTY_LIST = "–";
var MIN_RUN_LENGTH = 3;
var isContiguousRun = function (numbers) {
    return numbers.every(function (number, index) { return index === 0 || number === numbers[index - 1] + 1; });
};
/**
 * Formats issue numbers the way the numbering preview shows them: a contiguous run of three or more
 * collapses into a range, anything else is listed one by one; labelNumber wraps each number or range
 * in its localized label ("č. 77").
 */
export var formatIssueNumberList = function (numbers, labelNumber) {
    if (numbers.length === 0)
        return EMPTY_LIST;
    if (numbers.length >= MIN_RUN_LENGTH && isContiguousRun(numbers)) {
        return labelNumber("".concat(numbers[0], "\u2013").concat(numbers[numbers.length - 1]));
    }
    return numbers.map(function (number) { return labelNumber(String(number)); }).join(", ");
};
